export default __webpack_public_path__ + "images/39ac2a9c7483eb5571199a0718f15468-beauty.webp";